export function ToggleAccordionButton() {
    document.querySelectorAll<HTMLElement>(".ldn-accordion-item").forEach((item) => {
        const bottomBg = item.querySelector<HTMLElement>('.ldn-accordion-container');
        const btn = item.querySelector<HTMLElement>('.accordion-toggle-btn');
        const btnText = btn?.querySelector<HTMLElement>('.btn-text');
        const btnIcon = btn?.querySelector<HTMLElement>('.btn-icon');

        const collapseId = btn?.getAttribute('data-target');
        const collapseEl = collapseId
            ? item.querySelector<HTMLElement>(collapseId)
            : null;

        if (!collapseEl || !btnText || !btnIcon) return;

        //console.log(btn, "exists");

        const setUi = (expanded: boolean) => {
            btnText.textContent = expanded ? "Show Less" : "Show More";
            bottomBg.classList.toggle("show-bg", expanded);
            //btnIcon.classList.toggle("show-less", expanded);

            const icon = btn.querySelector<HTMLElement>(".btn-icon");
            icon?.classList.toggle("show-less", expanded);
        }

        setUi(collapseEl.classList.contains("show"));

        $(collapseEl).on("show.bs.collapse", () => setUi(true));
        $(collapseEl).on("hide.bs.collapse", () => setUi(false));
    });
}
